let language = {
    "A113B001": "此订单没有税率，因此我们无法确定定价。请访问相关页面并提供此信息。谢谢。",
    "A113B002": "此订单没有税率，因此我们无法确定定价。请访问相关页面并提供此信息。谢谢。",

    "A113B003": "当前订单与登录的合作伙伴账户不匹配。",
    "A113B004": "当前订单不属于您登录的合作伙伴帐户，请检查您的帐户或使用正确的凭据登录",

    "A113B005": "不支持拼单类型，仅支持零售订单",
    "A113B006": "不支持拼单类型，仅支持零售订单",

    "A113B007": "重量单位错误",
    "A113B008": "重量单位错误",

    "A113B009": "您可能提交了错误的订单ID，导致URL被更改，导致我们无法找到该订单。请检查并重新提交。谢谢。",
    "A113B010": "您可能提交了错误的订单ID，导致URL被更改，导致我们无法找到该订单。请检查并重新提交。谢谢。",

    "A113B011": "提供的送货地址有误，特别是邮政编码，与所选送货国家/地区不匹配。请检查并重试",
    "A113B012": "提供的送货地址有误，特别是邮政编码，与所选送货国家/地区不匹配。请检查并重试",

    "A113B013": "无法获取产品定价表",
    "A113B014": "抱歉，出现错误，我们无法获取您请求的价格表。请联系我们的技术团队寻求帮助：{{supportmail}}",

    "A113B015": "信息为空或所需数据不合法",
    "A113B016": "信息为空或所需数据不合法",

    "A113B017": "无法获取运费",
    "A113B018": "我们无法获取运费。请检查您的输入并重试。如果问题仍然存在，请与我们联系并提供包含您的商店 ID 和产品 ID 的当前 URL。",

    "A113B019": "目前的订单已经合并",
    "A113B020": "目前的订单已经合并",

    "A113B021": "当前订单不属于当前合作伙伴",
    "A113B022": "当前订单似乎不属于当前合作伙伴。如需更多信息，请联系 {{supportmail}} 解决该问题。",

    "A113B023": "合作伙伴 ID 不存在",
    "A113B024": "合作伙伴 ID 不存在",

    "A113B025": "不支持此订单所选的送货方式",
    "A113B026": "您可以在我们的网站上选择其他可用的送货方式",

    "A113B027": "URL 中缺少参数",
    "A113B028": "URL 不完整。请检查其准确性，然后重新提交并刷新页面。",

    "A113B029": "组订单自动分组但未指定订单用户",
    "A113B030": "组订单自动分组但未指定订单用户",

    "A113B031": "以下国家/地区不支持配送: \n{{region}}.",
    "A113B032": "以下国家/地区不支持配送: \n{{region}}.",

    "A113B033": "店铺零售订单项不存在: \n{{notExistOrderItemIds}}.",
    "A113B034": "客户订单不存在，无法合并：: \n{{notExistOrderIds}}.",
    "A113B035": "店铺不存在: \n{{notExistStoreIds}}.",

    BULK_ORDER_CHECKOUT_CALC_PRICE_FAIL_TITLE: "计价失败",
    BULK_ORDER_CHECKOUT_CURRENCY_ERROE_TITLE:"组合订单错误",
    BULK_ORDER_CHECKOUT_CURRENCY_NONSUPPORT_CONTENT:"当前不支持您首选的货币类型。 请点击页面顶部的\"{{updateCurrencyBtn}}\" 按钮更新货币。 ",
    A113B3000601: "当前货币: {{currentCurrency}}, {{appName}}平台支持的货币类型：: {{supportCurrencies}}。",
    A113B300310: "系统中不存在货币 {{currentCurrency}}。",
    
    BULK_ORDER_CHECKOUT_EXIST_NOT_BELONG_USER_ITEM_TITLE: "合并订单错误",
    BULK_ORDER_CHECKOUT_EXIST_NOT_BELONG_USER_ITEM_CONTENT: "存在不属于当前登录用户的可拼单项",
    
    BULK_ORDER_LIST_INFO_TIPS_TITLE_STORE: '订单不匹配',
    BULK_ORDER_STORE_INFO_TIPS_TITLE: '合作伙伴账户无效',
    BULK_ORDER_LIST_INFO_TIPS_TITLE_TAX_CONFIG: '缺少税率',
    BULK_ORDER_LIST_INFO_TIPS_TITLE_INVALID_ORDER: '未找到当前订单',
    BULK_ORDER_LIST_INFO_TIPS_TITLE_INVALID_STORE_ORDER: '商店订单无效',
    BULK_ORDER_LIST_INFO_TIPS_TITLE_INVALID_ADDRESS: '送货地址信息无效',
    BULK_ORDER_LIST_INFO_TIPS_TITLE_INVALID_PRICING: '运费计算错误',
    BULK_ORDER_CONFIGURATION_INFO_TIPS_TITLE: '配置无效',
    BULK_ORDER_CONFIGURATION_INFO_TIPS_TITLE_INVALID_USER: '订单不匹配合作商店',
    BULK_ORDER_CODE_INFO_TIPS_TITLE: '优惠券代码无效',
    BULK_ORDER_LIST_INFO_TIPS_TITLE_PAYMENT_FAILED: "订单支付失败",
    BULK_ORDER_LIST_INFO_TIPS_TITLE_PAYMENT_FAILED_DES1: "网站暂不支持该类型的支付方式，请重新选择订单支付类型后重试，或联系技术人员 {{supportmail}}处理。",
    BULK_ORDER_CREATE_ORDER_ISSUE_TITLE: "创建订单异常",
    BULK_ORDER_CREATE_ORDER_BY_CURRENCY_ISSUE_CONTENT: "货币类型更改。请查看您的订单信息，然后重新下单。",
    BULK_ORDER_PAGE_INIT_ISSUE_TITLE: "页面加载异常",
    BULK_ORDER_PAGE_INIT_ISSUE_CONTENT: "加载此页时发生问题。 请刷新页面再试一次。如果问题仍然存在，请随时与我们的支持团队联系{{supportmail}}。",
    A113B036: "检索用户货币偏好设置出错。",

    // 300523:"店铺id: {storeIds}  不属于当前登录用户！",
    // 300591:"不支持的拼单类型,仅支持零售订单",
    // 300593:"可拼单项为空",
    // 300584:"计算价格Price为空",
    // 300585:"不合法的价格信息",
    // 300586:"价格信息的金额数值为空！",
    // 300587:"货币信息为空！",
    // 300588:"货币信息的货币代码为空！",
    // 300589:"不支持货币代码：{code} !",

    // 300518:"下单item为空,空id数组",
    // 300519:"下单零售订单id为空",
    // 300590:"计重单位错误",
    // 1500013:"稅地址校验失败",
    // 1500014:"地址校驗超時",
    // 1500015:"地址校验失败",
    // 1500016:"地址校验失败",

    // 300583:"匿名用户网站代码不能为空！",
    // 300581:"user绑定的website不存在",
    // 3005822:"订单项已经拼单",
    // 300517:"不支持此运输方式",
    // 400600:"拼单下单为自动拼单但是未指定下单用户",
    // 400506:"user不属于任何partner",
};

export { language }